<!-- 寄信確認彈窗 -->
<div class="email-confirmation-modal" *ngIf="show" (keydown)="onKeydown($event)">
  <!-- 背景遮罩 -->
  <div class="modal-backdrop"></div>

  <!-- 主要彈窗內容 -->
  <div class="modal-content">
    <!-- 標題列 -->
    <div class="modal-header">
      <h3 class="modal-title">
        <i class="fas fa-envelope"></i>
        {{ title }}
      </h3>
      <div class="modal-summary">
        <span class="summary-badge">
          已選擇 {{ selectedEmailsCount }} / {{ totalEmailsCount }} 封郵件
        </span>
      </div>
      <button class="btn-close" (click)="closeModal()" title="關閉">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- 施工資訊摘要 -->
    <div class="construction-summary" *ngIf="showConstructionInfo && constructionInfo">
      <h4><i class="fas fa-info-circle"></i> 施工資訊</h4>
      <div class="summary-content">
        <div class="info-row">
          <label>承攬商：</label>
          <span>{{ constructionInfo.contractorCompany?.companyName || '未指定' }}</span>
        </div>
        <div class="info-row">
          <label>施工期間：</label>
          <span>
            <ng-container *ngIf="constructionInfo.workPeriod?.startDate && constructionInfo.workPeriod?.endDate && constructionInfo.workPeriod.startDate !== '未設定' && constructionInfo.workPeriod.endDate !== '未設定'; else pendingPeriod">
              {{ constructionInfo.workPeriod.startDate }} ~ {{ constructionInfo.workPeriod.endDate }}
            </ng-container>
            <ng-template #pendingPeriod>待填寫</ng-template>
          </span>
        </div>
        <div class="info-row">
          <label>工作人員：</label>
          <span>
            <ng-container *ngIf="constructionInfo.workers && constructionInfo.workers.length > 0; else pendingWorkers">
              {{ constructionInfo.workers.length }} 人
            </ng-container>
            <ng-template #pendingWorkers>待填寫</ng-template>
          </span>
        </div>
      </div>
    </div>

    <!-- 郵件列表 -->
    <div class="modal-body">
      <!-- 批量操作 -->
      <div class="batch-controls">
        <label class="checkbox-container">
          <input type="checkbox"
                 [(ngModel)]="selectAll"
                 (change)="onSelectAllChange()">
          <span class="checkmark"></span>
          全選 / 取消全選
        </label>
      </div>

      <!-- 郵件清單 -->
      <div class="emails-list">
        <div class="email-item"
             *ngFor="let email of emails; let i = index"
             [class]="getEmailStatusClass(email)">

          <!-- 選擇框 -->
          <div class="email-selection">
            <label class="checkbox-container">
              <input type="checkbox"
                     [(ngModel)]="email.selected"
                     (change)="onEmailSelectionChange()">
              <span class="checkmark"></span>
            </label>
          </div>

          <!-- 郵件資訊 -->
          <div class="email-info">
            <div class="email-header">
              <div class="email-type-badge">
                {{ getEmailTypeLabel(email) }}
              </div>
              <div class="email-subject">
                <strong>{{ email.subject }}</strong>
              </div>
            </div>

            <div class="email-recipients">
              <div class="recipient-line">
                <label>收件人：</label>
                <span class="recipients-list">{{ email.to.join(', ') }}</span>
              </div>
              <div class="recipient-line" *ngIf="email.cc.length > 0">
                <label>副本：</label>
                <span class="recipients-list">{{ email.cc.join(', ') }}</span>
              </div>
            </div>

            <!-- 工作人員資訊 -->
            <div class="worker-info" *ngIf="email.workerInfo">
              <i class="fas fa-user"></i>
              {{ email.workerInfo.name }}
              <span *ngIf="email.workerInfo.phone">({{ email.workerInfo.phone }})</span>
            </div>
          </div>

          <!-- 操作按鈕 -->
          <div class="email-actions">
            <button class="btn btn-sm btn-outline-primary"
                    (click)="previewEmail(email)"
                    title="預覽內容">
              <i class="fas fa-eye"></i>
            </button>
            <button class="btn btn-sm btn-outline-secondary"
                    (click)="startEditEmail(email)"
                    title="編輯">
              <i class="fas fa-edit"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部按鈕 -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="cancelSend()">
        <i class="fas fa-times"></i>
        取消
      </button>
      <button class="btn btn-primary"
              (click)="confirmSend()"
              [disabled]="selectedEmailsCount === 0">
        <i class="fas fa-paper-plane"></i>
        發送 {{ selectedEmailsCount }} 封郵件
      </button>
    </div>
  </div>

  <!-- 郵件內容預覽彈窗 -->
  <div class="preview-modal" *ngIf="showPreview && currentPreviewEmail">
    <div class="preview-backdrop"></div>
    <div class="preview-content">
      <div class="preview-header">
        <h4>郵件內容預覽</h4>
        <div class="preview-navigation">
          <button class="btn btn-sm btn-outline-secondary"
                  [disabled]="currentEmailIndex === 0"
                  (click)="previousEmail()">
            <i class="fas fa-chevron-left"></i> 上一封
          </button>
          <span class="nav-info">{{ currentEmailIndex + 1 }} / {{ emails.length }}</span>
          <button class="btn btn-sm btn-outline-secondary"
                  [disabled]="currentEmailIndex === emails.length - 1"
                  (click)="nextEmail()">
            下一封 <i class="fas fa-chevron-right"></i>
          </button>
        </div>
        <button class="btn-close" (click)="closePreview()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="preview-body">
        <div class="preview-info">
          <div class="info-row">
            <label>主旨：</label>
            <span>{{ currentPreviewEmail.subject }}</span>
          </div>
          <div class="info-row">
            <label>收件人：</label>
            <span>{{ currentPreviewEmail.to.join(', ') }}</span>
          </div>
          <div class="info-row" *ngIf="currentPreviewEmail.cc.length > 0">
            <label>副本：</label>
            <span>{{ currentPreviewEmail.cc.join(', ') }}</span>
          </div>
        </div>

        <div class="content-preview">
          <div [innerHTML]="currentPreviewEmail.htmlContent"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- 郵件編輯彈窗 -->
  <div class="edit-modal" *ngIf="editingEmail">
    <div class="edit-backdrop"></div>
    <div class="edit-content">
      <div class="edit-header">
        <h4>編輯郵件</h4>
        <button class="btn-close" (click)="cancelEmailEdit()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="edit-body">
        <!-- 主旨編輯 -->
        <div class="form-group">
          <label>主旨：</label>
          <input type="text"
                 class="form-control"
                 [(ngModel)]="editingEmail.subject">
        </div>

        <!-- 收件人編輯 -->
        <div class="form-group">
          <label>收件人 (TO)：</label>
          <input type="text"
                 class="form-control"
                 placeholder="請輸入收件人信箱，多個信箱請用逗號分隔"
                 [(ngModel)]="toRecipientsText">
          <small class="form-text text-muted">
            多個信箱請用逗號分隔，例如：user1&#64;example.com, user2&#64;example.com
          </small>
        </div>

        <!-- CC 編輯 -->
        <div class="form-group">
          <label>副本 (CC)：</label>
          <input type="text"
                 class="form-control"
                 placeholder="請輸入副本收件人信箱，多個信箱請用逗號分隔"
                 [(ngModel)]="ccRecipientsText">
          <small class="form-text text-muted">
            多個信箱請用逗號分隔，例如：cc1&#64;example.com, cc2&#64;example.com
          </small>
        </div>

        <!-- 內容預覽 -->
        <div class="form-group">
          <label>內容預覽：</label>
          <div class="content-preview-box">
            <div [innerHTML]="editingEmail.htmlContent" class="html-preview"></div>
          </div>
          <small class="form-text text-muted">
            內容為唯讀預覽，無法編輯
          </small>
        </div>
      </div>

      <div class="edit-footer">
        <button class="btn btn-secondary" (click)="cancelEmailEdit()">
          取消
        </button>
        <button class="btn btn-primary" (click)="saveEmailEdit()">
          <i class="fas fa-save"></i> 儲存
        </button>
      </div>
    </div>
  </div>
</div>
